import { render, staticRenderFns } from "./global-modal.vue?vue&type=template&id=940c3b62&"
import script from "./global-modal.vue?vue&type=script&lang=js&"
export * from "./global-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports